'use client';

import { useState, useTransition } from 'react';

import { useExitImpersonation } from '@ci/supabase/impersonation';
import { Button } from '@ci/ui/button';
import { Trans } from '@ci/ui/trans';

export function ImpersonationExitControl({ name }: { name: string }) {
  const exitImpersonation = useExitImpersonation();
  const [pending, startTransition] = useTransition();
  const [failed, setFailed] = useState(false);

  return (
    <aside
      data-test="impersonation-banner"
      className="fixed inset-x-2 bottom-3 z-[100] mx-auto flex w-fit max-w-[calc(100%-1rem)] flex-wrap items-center justify-center gap-x-2 rounded-lg border border-amber-600 bg-amber-100 px-3 py-1 text-sm text-amber-950 shadow-md"
    >
      <span className="min-w-0 break-all">
        <Trans i18nKey="common.impersonation.active" values={{ name }} />
      </span>
      <span aria-hidden>·</span>
      <Button
        variant="link"
        size="sm"
        className="h-8 text-inherit underline"
        disabled={pending}
        onClick={() => {
          setFailed(false);
          startTransition(async () => {
            try {
              await exitImpersonation();
            } catch {
              setFailed(true);
            }
          });
        }}
      >
        <Trans i18nKey="common.impersonation.exit" />
      </Button>
      {failed ? (
        <span role="alert" className="w-full text-center">
          <Trans i18nKey="common.impersonation.exitFailed" />
        </span>
      ) : null}
    </aside>
  );
}
